export default "__VITE_ASSET__b9CjVdUG__"